var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"html",staticClass:"content mb-2",domProps:{"innerHTML":_vm._s(_vm.html)}}),(_vm.data.caption)?_c('p',{staticClass:"has-text-centered"},[_vm._v(" "+_vm._s(_vm.data.caption)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }